/*
 * Generated from Helvetica-Oblique.afm. Do not edit directly.
 * The source AFM metrics were converted to JavaScript; this is a modification.
 * Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.
 *
 * This file and the 14 PostScript(R) AFM files it accompanies may be used, copied, and distributed for any purpose and without charge, with or without modification, provided that all copyright notices are retained; that the AFM files are not distributed without this file; that all modifications to this file or any of the AFM files are prominently noted in the modified file(s); and that this paragraph is not modified. Adobe Systems has no responsibility or obligation to support the use of the AFM files.
 */
import glyphNames from './standardGlyphNames.js';
export default {
  name: 'Helvetica-Oblique',
  bbox: [-170, -225, 1116, 931],
  ascender: 718,
  descender: -207,
  xHeight: 523,
  capHeight: 718,
  glyphNames,
  glyphWidths: [
    278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278,
    278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584,
    584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556,
    833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278,
    278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222,
    500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500,
    500, 334, 260, 334, 584, 556, 222, 556, 333, 1000, 556, 556, 333, 1000, 667,
    333, 1000, 611, 222, 222, 333, 333, 350, 556, 1000, 333, 1000, 500, 333,
    944, 500, 500, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584,
    737, 333, 400, 584, 333, 333, 333, 556, 537, 278, 333, 333, 365, 556, 834,
    834, 834, 611, 667, 667, 667, 667, 667, 667, 1000, 722, 667, 667, 667, 667,
    278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722,
    722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556,
    556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 584, 611,
    556, 556, 556, 556, 500, 556,
  ],
  kernPairs: [
    -180,
    [10332, 2],
    -160,
    [9569],
    -150,
    [8182, 2],
    -140,
    [
      9517, 54, 70, 1552, 1074, 1, 1, 51, 4, 10, 105, 1, 1, 1, 1, 1, 3, 1, 1, 1,
      7, 1, 1, 1, 1, 2, 26464, 1, 1, 51, 4, 10, 105, 1, 1, 2, 1, 3, 1, 1, 1, 7,
      1, 1, 1, 1, 2,
    ],
    -125,
    [11622, 2],
    -120,
    [
      7147, 3206, 119, 1, 1, 1, 1, 1, 715, 2, 19, 32, 4, 10, 3, 3, 2, 2, 63, 1,
      1, 1, 1, 1, 27, 1, 1, 2, 1, 4, 1, 1, 7, 1, 1, 2, 2, 1, 1, 1, 1, 1, 21339,
      215, 215, 215, 215, 215,
    ],
    -110,
    [
      9512, 2, 2774, 52, 67, 1, 1, 1, 1, 1, 52, 1, 1, 1, 26481, 52, 67, 1, 1, 1,
      1, 1, 52, 1, 1, 1,
    ],
    -100,
    [
      2689, 2, 428, 2, 4031, 124, 11871, 2, 6878, 2, 6708, 124, 91, 124, 91,
      124, 91, 124, 91, 124, 91, 124, 11871, 2,
    ],
    -95,
    [44732, 2],
    -90,
    [57, 124, 7616, 124],
    -85,
    [12302, 123, 1, 1, 1, 1, 2, 26531, 123, 1, 1, 1, 1, 2, 5717],
    -80,
    [
      8203, 119, 1, 1, 1, 1, 1, 3296, 20, 36, 10, 73, 1, 1, 1, 1, 1, 35, 1, 1,
      1, 7, 1, 1, 1, 1, 2, 19, 2, 6663, 2,
    ],
    -70,
    [
      7149, 603, 2, 40, 1721, 647, 124, 1389, 20, 99, 1, 1, 1, 1, 1, 20, 1, 1,
      1, 11613, 9299, 215, 215, 215, 215, 215, 2798, 124, 91, 124, 91, 124, 91,
      124, 91, 124, 306, 124, 1081, 5704, 1, 2, 32, 92,
    ],
    -60,
    [
      108, 2902, 7151, 1140, 66, 5, 13, 896, 1, 6435, 2, 17887, 215, 215, 215,
      215, 430, 1045, 1,
    ],
    -57,
    [23328, 216],
    -55,
    [
      44785, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 27,
      3, 64, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 2, 1,
      1, 1, 1,
    ],
    -50,
    [
      52, 2, 5536, 215, 1343, 2, 122, 1, 1, 1, 960, 119, 1, 1, 1, 1, 1, 933, 42,
      32, 49, 1, 1, 1, 1, 2, 37, 701, 230, 10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2,
      276, 3, 124, 927, 119, 1, 1, 1, 1, 1, 5660, 2, 5859, 14, 1, 34, 9181, 2,
      122, 1, 1, 1, 88, 2, 122, 1, 1, 1, 88, 2, 122, 1, 1, 1, 88, 2, 122, 1, 1,
      1, 88, 2, 122, 1, 1, 1, 88, 2, 122, 1, 1, 1, 2669, 215, 215, 215, 215,
      430,
    ],
    -45,
    [8252],
    -40,
    [
      55, 7126, 1, 2, 32, 92, 465, 22, 97, 1, 1, 1, 1, 1, 1417, 10, 113, 1, 1,
      1, 7, 1, 1, 1, 1, 2, 664, 2, 38, 228, 119, 1, 1, 1, 1, 1, 294, 124, 1, 1,
      1, 297, 123, 1, 1, 1, 1, 2, 51, 2, 19, 119, 1, 1, 1, 1, 1, 84, 1, 12, 8,
      123, 1, 1, 1, 1, 2, 52, 52, 119, 1, 1, 1, 1, 1, 2188, 2, 2793, 2, 6866,
      8901, 1, 2, 32, 92, 88, 1, 2, 32, 92, 88, 1, 2, 32, 92, 88, 1, 2, 32, 92,
      88, 1, 2, 32, 92, 88, 1, 2, 32, 92, 2594, 2, 38, 175, 2, 38, 175, 2, 38,
      175, 2, 38, 175, 2, 38, 390, 2, 38, 175, 2, 19, 119, 1, 1, 1, 1, 1, 70, 2,
      19, 119, 1, 1, 1, 1, 1, 70, 2, 19, 119, 1, 1, 1, 1, 1, 70, 2, 19, 119, 1,
      1, 1, 1, 1, 4585, 2, 213, 2, 213, 2, 213, 2, 213, 2,
    ],
    -35,
    [17212, 2],
    -30,
    [
      110, 7020, 4, 8, 2, 36, 74, 11, 1, 1, 1, 1, 2, 33, 1, 1, 1, 230, 2, 700,
      10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2, 664, 2, 286, 124, 1, 1, 1, 92, 32, 92,
      487, 642, 3, 1089, 10, 6, 107, 1, 1, 1, 7, 1, 1, 1, 1, 2, 1, 1, 1, 1,
      2027, 32, 92, 733, 2, 139, 2, 51, 4, 10, 105, 1, 1, 1, 1, 1, 3, 1, 1, 1,
      7, 1, 1, 1, 1, 2, 311, 32, 92, 1380, 1, 32, 92, 91, 32, 92, 519, 1057,
      123, 1, 1, 1, 6127, 7473, 4, 8, 2, 36, 74, 11, 1, 1, 1, 1, 2, 33, 1, 1, 1,
      38, 4, 8, 2, 36, 74, 11, 1, 1, 1, 1, 2, 33, 1, 1, 1, 38, 4, 8, 2, 36, 74,
      11, 1, 1, 1, 1, 2, 33, 1, 1, 1, 38, 4, 8, 2, 36, 74, 11, 1, 1, 1, 1, 2,
      33, 1, 1, 1, 38, 4, 8, 2, 36, 74, 11, 1, 1, 1, 1, 2, 33, 1, 1, 1, 38, 4,
      8, 2, 36, 74, 11, 1, 1, 1, 1, 2, 33, 1, 1, 1, 230, 2, 2406, 215, 215, 215,
      215, 430, 1754, 32, 92, 91, 32, 92, 91, 32, 92, 91, 32, 92, 91, 32, 92,
      91, 32, 92, 518, 2, 213, 2, 213, 2, 213, 2, 1505, 1, 32, 92, 90, 1, 32,
      92, 90, 1, 32, 92, 90, 1, 32, 92, 90, 1, 32, 92,
    ],
    -25,
    [18555, 4, 10, 105, 1, 1, 1, 1, 1, 3, 1, 1, 1, 7, 1, 1, 1, 1, 2],
    -20,
    [
      7322, 2, 1739, 32, 20, 67, 1, 1, 1, 1, 1, 27, 1, 1, 1, 1, 1, 20, 1, 1, 1,
      896, 119, 1, 1, 1, 1, 1, 535, 123, 1, 1, 1, 1, 2, 51, 2, 227, 1, 665, 42,
      32, 49, 1, 1, 1, 1, 2, 37, 290, 124, 1609, 1, 204, 9, 1, 3, 32, 88, 1, 1,
      1, 1, 77, 442, 2, 32, 92, 1146, 10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2, 523,
      2344, 4, 10, 105, 1, 1, 1, 1, 1, 3, 1, 1, 1, 7, 1, 1, 1, 1, 2, 3029, 2,
      3706, 4, 10, 105, 1, 1, 1, 1, 1, 3, 1, 1, 1, 7, 1, 1, 1, 1, 2, 10360, 119,
      1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 91, 119, 1,
      1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 306, 119, 1, 1, 1, 1, 1, 991, 124,
      534, 1, 214, 1, 214, 1, 214, 1, 214, 1, 214, 1, 418, 227, 2, 32, 92, 89,
      2, 32, 92, 89, 2, 32, 92, 89, 2, 32, 92, 1163, 2559, 4, 10, 105, 1, 1, 1,
      1, 1, 3, 1, 1, 1, 7, 1, 1, 1, 1, 2,
    ],
    -15,
    [
      14417, 430, 2, 1795, 32, 92, 91, 32, 92, 88, 1, 785, 2, 911, 119, 1, 1, 1,
      1, 1, 525, 10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2, 5609, 2, 700, 10, 113, 1,
      1, 1, 7, 1, 1, 1, 1, 2, 15069, 215, 2, 213, 2, 213, 2, 213, 2, 1365, 32,
      92, 88, 1, 214, 1, 214, 1, 214, 1, 214, 1,
    ],
    -10,
    [
      7363, 124, 1, 1, 1, 3098, 124, 1, 1, 1, 3541, 1091, 1293, 124, 1, 1, 1,
      88, 124, 1, 1, 1, 713, 119, 1, 1, 1, 1, 1, 955, 10, 113, 1, 1, 1, 7, 1, 1,
      1, 1, 2, 24387, 124, 1, 1, 1,
    ],
    15,
    [17703, 2, 1, 9, 111, 1, 1, 1, 10, 1, 1, 1],
    25,
    [17707, 1, 123],
    30,
    [17656, 1, 53, 6, 3, 32, 92],
    40,
    [17714],
    50,
    [15159],
    60,
    [15161],
  ],
};
